import { HttpHandler } from 'msw'

import { cancelOrder } from './cancelOrder'
import { createOrder } from './createOrder'
import { getAllOrders } from './getAllOrders'
import { getOrder } from './getOrder'
import { updateOrderInPreparation } from './updateOrderInPreparation'

export const orders: HttpHandler[] = [
    cancelOrder,
    createOrder,
    getAllOrders,
    getOrder,
    updateOrderInPreparation,
]
